import { FC } from 'react';

import { NbButton, NbCard, NbPageHeader } from '@/components/Neobrut';

export const Us: FC = () => {
  return (
    <div className="mx-auto w-full max-w-2xl lg:max-w-3xl pb-10">
      <NbPageHeader
        slug="/ nosotros"
        title={
          <>
            Somos dos
            <br />
            <span className="nb-highlight">nomás.</span>
          </>
        }
        tone="plain"
      />

      <div className="flex flex-col gap-3 px-4 pt-4">
        <NbCard className="p-4">
          <p className="text-[14px] leading-relaxed">
            ¡Hola! Somos <b>Andrés</b> y <b>Victoria</b>. Combinamos nuestro amor por los
            animales y nuestras habilidades para crear <b>RescatApp</b>, un espacio para
            facilitar el reencuentro entre mascotas perdidas y sus familias.
          </p>
        </NbCard>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <NbCard className="fill-lost p-4">
            <div
              className="text-[10px] font-bold uppercase tracking-[0.08em]"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              / andrés
            </div>
            <div className="font-display mt-1 text-[22px] leading-none">Developer</div>
            <p className="mt-2 text-[13px]">A cargo del desarrollo de la app.</p>
          </NbCard>
          <NbCard className="fill-found p-4">
            <div
              className="text-[10px] font-bold uppercase tracking-[0.08em]"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              / victoria
            </div>
            <div className="font-display mt-1 text-[22px] leading-none">Diseño + difusión</div>
            <p className="mt-2 text-[13px]">Diseño y comunicación del proyecto.</p>
          </NbCard>
        </div>

        <NbCard className="p-4">
          <p className="text-[14px] leading-relaxed">
            La idea nació al ver lo difícil que es conectar a quienes pierden a sus compañeros
            peludos con quienes los encuentran. Por eso pusimos manos a la obra.
          </p>
        </NbCard>

        <NbCard className="fill-ink p-4 text-white">
          <div
            className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-70"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            / cómo ayudar
          </div>
          <div
            className="font-display mt-1 text-[22px] leading-none"
            style={{ color: 'var(--nb-paper)' }}
          >
            La app es gratis.
            <br />
            Mantenerla, no.
          </div>
          <p className="mt-2 text-[13px] opacity-90">
            Aunque la app es gratuita, mantenerla activa y mejorarla requiere recursos. Si te
            reencontraste con tu amigo peludo, o simplemente querés bancar el proyecto, podés
            donar a voluntad.
          </p>
          <a
            href="https://link.mercadopago.com.ar/rescatapp"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-block"
          >
            <NbButton fill="lost" className="px-4 py-3 text-[13px]">
              Hacer una donación →
            </NbButton>
          </a>
        </NbCard>

        <NbCard className="fill-solved p-4">
          <p className="text-[14px] font-medium">
            También nos ayuda muchísimo <b>difundir</b> RescatApp entre tus contactos, redes o
            medios. Cuanta más gente lo conozca, más animales pueden volver a casa.
          </p>
        </NbCard>
      </div>
    </div>
  );
};
